import { useState } from "react";
import { toast } from "sonner";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";
import { api, apiError } from "../lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export function PlaquetteEmailForm({ source = "plaquette", compact = false }) {
  const [f, setF] = useState({ email: "", nom: "", structure: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/plaquette/envoyer", { ...f, source });
      toast.success(data.message);
      setDone(true);
    } catch (err) { toast.error(apiError(err, "Envoi impossible")); } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="flex items-center gap-3 rounded-2xl border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800" data-testid="plaquette-email-success">
        <CheckCircle2 size={20} className="shrink-0 text-emerald-600" /> La plaquette est en route vers <b>{f.email}</b>. Pensez à vérifier vos courriers indésirables.
      </div>
    );
  }
  return (
    <form onSubmit={submit} className={`grid gap-3 ${compact ? "sm:grid-cols-[1fr_auto]" : "sm:grid-cols-3"}`} data-testid="plaquette-email-form">
      {!compact && <Input required value={f.nom} onChange={set("nom")} placeholder="Votre nom" data-testid="plaquette-email-nom" className="h-11 rounded-full border-[#7DC4E8] bg-white" />}
      {!compact && <Input value={f.structure} onChange={set("structure")} placeholder="Structure (cabinet, clinique, hôpital…)" data-testid="plaquette-email-structure" className="h-11 rounded-full border-[#7DC4E8] bg-white" />}
      <Input type="email" required value={f.email} onChange={set("email")} placeholder="votre@email.com" data-testid="plaquette-email-input" className="h-11 rounded-full border-[#7DC4E8] bg-white" />
      <Button type="submit" disabled={busy} data-testid="plaquette-email-submit" className={`h-11 rounded-full bg-[#0369A1] px-6 text-sm font-semibold text-white hover:bg-[#075985] ${compact ? "" : "sm:col-span-3 sm:justify-self-start"}`}>
        {busy ? <Loader2 size={16} className="mr-2 animate-spin" /> : <Mail size={16} className="mr-2" />} Recevoir la plaquette par email
      </Button>
    </form>
  );
}
